import { Area } from "Models/Areas/Area";
import { TaskRecurrencyType } from "Models/Tasks/TaskRecurrencies/TaskRecurrencyType";
import { RoleType } from "Models/Users/RoleType";

export class TaskTemplateFilterState {
    public skip: number;
    public take: number;
    public query: string;

    public recurrenceTypes?: TaskRecurrencyType[];
    public area?: Area;
    public roles?: RoleType[];
    public instructionsAttached?: boolean;
    public photoAttached?: boolean;
    public videoAttached?: boolean;
}


// WEBPACK FOOTER //
// ./src/Store/TaskTemplates/TaskTemplateFilterState.ts